export interface IEnvironment {
  name: string;
  production: boolean;
  services: {
    api: string;
  };
  sentryDsn?: string;
  googleAnalyticsId?: string;
  frontappChatId?: string;
  cookieHub?: string;
}

export const SENTRY_DSN = 'https://26d18ba442f7466cae8ca8138d58c2d3@o445185.ingest.sentry.io/5660896';

export const PROD_API = '/backend/api/v1/crm';
